module.exports = __webpack_public_path__ + "static/media/ericburnik.3cacfef1.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/ericburnik.webp
// module id = 623
// module chunks = 0